import { formatPrice } from '@/utils';
import { storefrontClient } from '@/utils/storefront-client';
import { Alpine as AlpineType } from 'alpinejs';

export default (Alpine: AlpineType) => {
  Alpine.data('productQuickview', (props: any) => ({
    isOpen: false,
    product: null,

    open(e: any) {
      // document.body.style.overflowY = 'hidden';
      this.product = e.detail;
      this.isOpen = true;
      setTimeout(() => {
        window?.yotpo?.initWidgets();
      }, 300);
      document.getElementsByTagName('html')[0].classList.add("is-quickview-visible");
    },
    close() {
      this.isOpen = false;
      this.product = null;
      this.$nextTick(() => {
        document.body.style.overflowY = '';
        document.getElementsByTagName('html')[0].classList.remove("is-quickview-visible");
      });
    },
    async quickbuyHandler(e: any) {
      if (!e?.detail?.slug) {
        return;
      }

      const query = `query($handle: String!) {
        productByHandle(handle: $handle) {
          status: metafield(key: "status", namespace: "custom") {
            value
          }
          id
          title
          tags
          handle
          lSGBuyBox: metafield(key: "lsg_buy_box", namespace: "custom") {
              reference {
                  ... on Metaobject {
                    short_description: field(key: "short_description") {
                      value
                    }
                    accordion: field(key: "accordion") {
                      references(first: 100) {
                        edges {
                          node {
                            ... on Metaobject {
                              heading: field(key: "heading") {
                                value
                              }
                              description: field(key: "description") {
                                value
                              }
                              grid: field(key: "grid") {
                                references(first: 100) {
                                  edges {
                                    node {
                                      ... on Metaobject {
                                        heading: field(key: "heading") {
                                          value
                                        }
                                        description: field(key: "description") {
                                          value
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
          benefits: metafield(key: "benefits", namespace: "filters") {
            references(first: 100) {
              edges {
                node {
                  ... on Metaobject {
                    name: field(key: "name") {
                      value
                    }
                  }
                }
              }
            }
          }
          productVariantName: metafield(key: "product_variant_name", namespace: "custom") {
            value
          }
          currentProductImage: media(first:1) {
            edges {
              node {
                ... on MediaImage {
                  image {
                    altText
                    url(transform: { maxHeight: 128, maxWidth: 128, crop: CENTER })
                  }
                }
              }
            }
          }
          productVariants: metafield(key: "product_variants", namespace: "custom") {
            references(first: 10) {
              edges {
                node {
                  ... on Product {
                    id
                    name: metafield(key: "product_variant_name", namespace: "custom") {
                      value
                    }
                    image: media(first:1) {
                      edges {
                        node {
                          ... on MediaImage {
                            image {
                              altText
                              url(transform: { maxHeight: 128, maxWidth: 128, crop: CENTER })
                            }
                          }
                        }
                      }
                    }
                    handle
                  }
                }
              }
            }
          }
          options(first: 1) {
            name
          }
          requiresSellingPlan
          amazonLink: metafield(namespace: "custom", key: "amazon_link") {
            value
          }
          variants(first: 10) {
            edges {
              node {
                id
                title
                availableForSale
                image {
                  transformedSrc(maxHeight: 700, maxWidth: 700)
                  altText
                }
                trumbnail: image {
                  transformedSrc(maxHeight: 50, maxWidth: 50)
                  altText
                }
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                }
                servingsPerContainer: metafield(namespace: "custom", key: "servings_per_container") {
                  value
                }
                freeShiping: metafield(namespace: "custom", key: "display_free_shipping_label") {
                  value
                }
                sellingPlanAllocations(first: 10) {
                  edges {
                    node {
                      priceAdjustments {
                        price {
                          amount
                        }
                      }
                      sellingPlan {
                        name
                        id
                      }
                    }
                  }
                }
                displayOnSite: metafield(namespace: "custom", key: "display_on_site") {
                  value
                }
                default: metafield(namespace: "custom", key: "default_variant") {
                  value
                }
                main_variant_id: metafield(namespace: "custom", key: "main_variant") {
                  value
                }
                qty: metafield(namespace: "custom", key: "qty") {
                  value
                }
              }
            }
          }
          carouselImages: metafield(namespace: "custom", key: "carousel_images") {
            references(first: 15) {
              edges {
                node {
                  ... on MediaImage {
                    image {
                      transformedSrc(maxHeight: 700, maxWidth: 700)
                    }
                    alt
                  }
                }
              }
            }
          }
          sellingPlanGroups(first: 10) {
            edges {
              node {
                appName
                name
                sellingPlans(first: 10) {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
          buttonCtaTextOneTime: metafield(namespace: "custom", key: "button_cta_text") {
            value
          }
          buttonCtaTextSubscribe: metafield(namespace: "custom", key: "button_cta_text_subscribe") {
            value
          }
          notAvailableButtonText: metafield(namespace: "custom", key: "not_available_button_text") {
            value
          }
        }
      }
      `;
      const { data } = await storefrontClient(query, { handle: e.detail.slug });

      if (!data?.productByHandle) {
        return;
      }

      this.open({ detail: this.dataToProductData(data.productByHandle) });
    },

    dataToProductData(data: any) {
      let main_variant_id = 0;
      let priceInCents = 0;
      let compareAtPriceInCents = 0;

      data?.variants?.edges
        ?.filter(({ node }: any) => node.displayOnSite.value === 'true')
        .forEach(({ node }: any) => {
          if (node.main_variant_id?.value === 'true') {
            priceInCents = parseFloat(node.price.amount) * 100;
            compareAtPriceInCents =
              parseFloat(node.compareAtPrice?.amount || 0) * 100;
            main_variant_id = Number(node.id.replace('gid://shopify/ProductVariant/', ''));
          }
        });

      const variants =
        data?.variants?.edges
          ?.filter(({ node }: any) => node.displayOnSite.value === 'true')
          ?.map(({ node }: any) => {
            const qty = Number(node.qty?.value) || 1;
            const servingsPerContainer = parseFloat(
              node.servingsPerContainer?.value || 0
            );
            let title = node.title;

            return {
              default: node?.default?.value === 'true',
              id: parseInt(
                node.id.replace('gid://shopify/ProductVariant/', '')
              ),
              title: title,
              description: title == '1-Pack' || title == '1-pack' ? 'Try It' : title == '2-Pack' ? 'Morning Routine' : title == '4-Pack' ? 'Twice A Day' : null,
              available: node.availableForSale,
              image: {
                src: node.image.transformedSrc,
                alt: node.image.altText || node.title,
              },
              trumbnail: node.trumbnail.transformedSrc,
              priceInCents: priceInCents * qty,
              price: formatPrice(priceInCents),
              compareAtPriceInCents: compareAtPriceInCents * qty,
              compareAtPrice: formatPrice(compareAtPriceInCents),
              discount:
                compareAtPriceInCents > priceInCents
                  ? Math.round((1 - priceInCents / compareAtPriceInCents) * 100)
                  : null,
              servingPrice: servingsPerContainer
                ? `${formatPrice(
                  Math.round(priceInCents / servingsPerContainer)
                )}/Serving`
                : null,
              freeShiping: node?.freeShiping?.value === 'true',
              sellingPlanAllocations: node?.sellingPlanAllocations?.edges?.map(
                ({ node }: any) => {
                  const priceInCents =
                    parseFloat(node.priceAdjustments[0].price.amount) * 100;

                  return {
                    sellingPlanId: parseInt(node.sellingPlan.id.replace('gid://shopify/SellingPlan/', '')),
                    name: node.sellingPlan.name,
                    priceInCents,
                    price: formatPrice(priceInCents),
                    discount:
                      compareAtPriceInCents > priceInCents
                        ? Math.round(
                          (1 - priceInCents / compareAtPriceInCents) * 100
                        )
                        : null,
                    servingPrice: servingsPerContainer
                      ? `${formatPrice(
                        Math.round(priceInCents / servingsPerContainer)
                      )}/Serving`
                      : null,
                  };
                }
              ),
              main_variant_id: main_variant_id,
              qty: Number(node.qty?.value) || 1,
            };
          }) || [];

      const defaultVariant =
        variants.find((item: any) => item.default) || variants[0];

      const hasSubscription =
        data?.sellingPlanGroups?.edges?.[0]?.node?.sellingPlans?.edges
          ?.length || false;

      return {
        id: parseInt(data?.id?.replace('gid://shopify/Product/', '')),
        status: data?.status?.value
          ? JSON.parse(data?.status?.value) || []
          : [],
        title: data.title,
        isBundleProduct: data?.tags?.includes('bundle-loop') || false,
        benefits:
          data?.benefits?.references?.edges?.map(
            ({ node }: any) => node.name.value
          ) || [],
        productVariants: data?.productVariants?.references?.edges?.length
          ? {
            currentProductName: data?.productVariantName?.value || '',
            currentProductImage: data?.currentProductImage?.edges[0]?.node?.image.url || '',
            products: data.productVariants.references.edges.map(
              ({ node }: any) => ({
                id: parseInt(node?.id?.replace('gid://shopify/Product/', '')),
                name: node.name.value,
                image: node.image?.edges[0]?.node?.image.url || '',
                url: `/products/${node.handle}`,
              })
            ),
          }
          : null,
        optionName: data?.options?.[0]?.name || '',
        requiresSellingPlan: data.requiresSellingPlan,
        amazonLink: data?.amazonLink?.value || '',
        variants,
        carouselImages: [
          defaultVariant.image,
          ...data?.carouselImages?.references?.edges?.map(({ node }: any) => ({
            src: node.image.transformedSrc,
            alt: node.alt || data.title,
          })),
        ],
        currentImageIndex: data?.carouselImages?.references?.edges?.length
          ? 1
          : 0,
        hasSubscription,
        enableSellingPlan: hasSubscription,
        sellingPlanGroup: hasSubscription
          ? {
            sellingPlans:
              data?.sellingPlanGroups?.edges?.[0]?.node?.sellingPlans?.edges?.map(
                ({ node }: any) => ({
                  id: node.id.replace('gid://shopify/SellingPlan/', ''),
                  name: node.name,
                })
              ),
          }
          : null,
        sellingPlanGroups: hasSubscription
          ? data?.sellingPlanGroups?.edges.map(({ node: { sellingPlans } }: any) => {
            return {
              selling_plans: sellingPlans?.edges?.map(
                ({ node }: any) => ({
                  id: parseInt(node.id.replace('gid://shopify/SellingPlan/', '')),
                  name: node.name,
                })
              ),
            }
          })
          : null,
        buttonCtaTextOneTime: data?.buttonCtaTextOneTime?.value || '',
        buttonCtaTextSubscribe: data?.buttonCtaTextSubscribe?.value || '',
        defaultVariant,
        notAvailableButtonText: data?.not_available_button_text?.value || 'Notify Me',
        currentVariantId: main_variant_id || defaultVariant.id,
        currentVariantTitle: defaultVariant.title.replace('-', ' '),
        currentVariantQty: defaultVariant.qty,
        show_onetime: data?.tags?.includes(window.onetimeTagName) || '',
        shortDescription: data?.lSGBuyBox?.reference?.short_description?.value,
        accordions: data?.lSGBuyBox?.reference?.accordion?.references?.edges?.map(
          ({ node }: any) => ({
            heading: node?.heading?.value,
            description: node?.description?.value,
            grid: node?.grid?.references?.edges?.map(
              ({ node }: any) => ({
                heading: node?.heading?.value,
                description: node?.description?.value
              })) || []
          })) || [],

      };
    },

    toHTML(content) {
      if (content == null) return null;
      let parsed = JSON.parse(content);
      let html = '';
      parsed.children.forEach((node) => {
        switch (node.type) {
          case 'heading':
            html += `<h${node.level}>${node.children[0].value}</h${node.level}>`;
            break;
          case 'list':
            html += `<${node.listType === 'unordered' ? 'ul' : 'ol'}>`;
            node.children.forEach((item) => {
              html += `<li>${item.children[0].value}</li>`;
            });
            html += `<${node.listType === 'unordered' ? '/ul' : '/ol'}>`;
            break;
          case 'paragraph':
            html += `<p>`;
            node.children.forEach((item) => {
              if (item.type === 'text' && item.bold) {
                html += `<strong>${item.value}</strong>` + ' ';
              } else if (item.type === 'text' && item.italic) {
                html += `<em>${item.value}</em>` + ' ';
              } else if (item.type === 'text') {
                html += `${item.value}` + ' ';
              }
              if (item.type === 'link' && item.bold) {
                html +=
                  `<a href="${item.url}" target="${item.target}"><strong>${item.children[0].value}</strong></a>` +
                  ' ';
              } else if (item.type === 'link' && item.italic) {
                html +=
                  `<a href="${item.url}" target="${item.target}"><em>${item.children[0].value}</em></a>` +
                  ' ';
              } else if (item.type === 'link') {
                html +=
                  `<a href="${item.url}" target="${item.target}">${item.children[0].value}</a>` + ' ';
              }
            });
            html += `</p>`;
            break;
        }
      });
      return html;
    },
  }));
};
